/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserFederationSource {
    Card = 'CARD'
}

export function UserFederationSourceFromJSON(json: any): UserFederationSource {
    return UserFederationSourceFromJSONTyped(json, false);
}

export function UserFederationSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserFederationSource {
    return json as UserFederationSource;
}

export function UserFederationSourceToJSON(value?: UserFederationSource | null): any {
    return value as any;
}

